module.exports = __webpack_public_path__ + "img/semaforo-active.22fea153.svg";